/** @format */
/*global google */

import React, { useEffect, useState } from "react";
import { geocodeByAddress } from "react-places-autocomplete";
import { Helmet } from "react-helmet";
import { metaDescription, propertyUrl } from "../Utils";
import AbsoluteRedirect from "../AbsoluteRedirect";
import { useLocation } from "react-router-dom";

// This component should replace OldApp's <Search> component and just redirects to the new /search-page
// New search page is /search , use this as a second route to redirect /search/:q and /search/:q/.../:propertyId
const SearchRedirect = ({ searchQuery }) => {
  const [formattedAddress, setFormattedAddress] = useState();

  useEffect(() => {
    if (!!searchQuery) {
      geocodeByAddress(searchQuery)
        .then((results) => results[0])
        .then((result) => {
          const formattedAddress = result.formatted_address;
          console.log(
            `Google geocodeByAddress from '${searchQuery}' to ${formattedAddress}`,
          );
          setFormattedAddress(formattedAddress);
        })
        .catch((error) => {
          console.error("Error", error);
          setFormattedAddress(searchQuery); // kick over to new page with whatever they typed in
        });
    }
  }, [searchQuery]);

  let q = formattedAddress || searchQuery;

  // If we got a google result from an URL, redirect
  if (formattedAddress) {
    return (
      <AbsoluteRedirect
        to={`/search?address=${formattedAddress.replaceAll(" ", "%20")}`}
      />
    );
  } else if (!searchQuery) {
    // Assume no searchQuery means we just hit /search, which we shouldn't need to handle here if that's the new App route?
    // do nothing
    console.log("old Search page got no query");
    return <AbsoluteRedirect to={`/search`} />;
  } else {
    console.log(
      `old Search page got query '${searchQuery}', awaiting google result`,
    );
    // We may flash this content during a Google Places lookup, but we don't expect to ever show this message intentionally.
    return (
      <React.Fragment>
        <Helmet>
          <title>
            Welltower Medical Office For Lease
            {q ? ` in ${q}` : ""} - Building Space For Rent
          </title>
          <meta name="description" content={metaDescription({ q })} />
          {/* TODO - put canonical short URL here? */}
        </Helmet>
        <p>
          The search page has moved.{" "}
          <a href={"/search"} style={{ textDecoration: "underline" }}>
            Click here
          </a>{" "}
          if you are not automatically redirected.
        </p>
      </React.Fragment>
    );
  }
};

const PropertyRedirect = ({ match }) => {
  const location = useLocation();
  if (match?.params?.propertyId) {
    return <AbsoluteRedirect to={propertyUrl(match.params.propertyId)} />;
  }
  if (location.search) {
    let urlQuery = new URLSearchParams(location.search);
    const propertyId = urlQuery.get("propertyId");
    if (propertyId) {
      return <AbsoluteRedirect to={propertyUrl(propertyId)} />;
    }
  }
  // TODO - redirect to /search ?
  return <AbsoluteRedirect to={"/search"} />;
};

export { SearchRedirect, PropertyRedirect };
